// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_array from "../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MetaStore$PorterinFeature from "../domain/store/MetaStore.mjs";
import * as AssetStore$PorterinFeature from "../../../ui/assets/AssetStore.mjs";
import * as OrderReviewStore$PorterinFeature from "../domain/store/OrderReviewStore.mjs";
import * as OrderReviewHelper$PorterinFeature from "../../order-review/domain/helpers/OrderReviewHelper.mjs";

var goods_type = {
  src: AssetStore$PorterinFeature.goodsType,
  width: 12.0,
  height: 12.0,
  alt: "Goods Type Icon"
};

var discount_tag = {
  src: AssetStore$PorterinFeature.discountTag,
  width: 20.0,
  height: 20.0,
  alt: "Discount Tag Icon"
};

var porter_gold_tag = {
  src: AssetStore$PorterinFeature.porterGoldTag,
  width: 20.0,
  height: 20.0,
  alt: "Porter Gold Icon"
};

var search = {
  src: AssetStore$PorterinFeature.search,
  width: 44.0,
  height: 44.0,
  alt: "Search Icon"
};

function getSeoContent(param) {
  return {
          title: OrderReviewStore$PorterinFeature.seo_title,
          meta_description: OrderReviewStore$PorterinFeature.seo_description,
          local_data: /* [] */0,
          image: {
            path: MetaStore$PorterinFeature.default_image_src,
            alt_text: MetaStore$PorterinFeature.default_image_alt
          },
          is_no_index: false
        };
}

function moveToStart(all_vehicles, selected_vehicle_index) {
  var index = Js_array.findIndex((function (item) {
          return item.vehicle_id === selected_vehicle_index;
        }), all_vehicles);
  if (index === -1) {
    return all_vehicles;
  }
  var selected_vehicle = Caml_array.get(all_vehicles, index);
  var remove_selected_vehicle = Belt_Array.keepWithIndex(all_vehicles, (function (param, i) {
          return i !== index;
        }));
  return Belt_Array.concat([selected_vehicle], remove_selected_vehicle);
}

function createVehiclesVm(all_vehicles, quotation, restricted_vehicles, selected_vehicle) {
  if (all_vehicles === undefined) {
    return [];
  }
  var available_vehicles = [];
  Js_array.forEach((function (item) {
          var vehicle_details = Js_array.find((function (details) {
                  return item.vehicle_id === details.id;
                }), all_vehicles.vehicles.on_demand);
          if (vehicle_details === undefined) {
            return ;
          }
          var vehicle_vm_vehicle_id = item.vehicle_id;
          var vehicle_vm_quotation_uuid = OrderReviewHelper$PorterinFeature.vehicleQuotationUuid(quotation, item.vehicle_id);
          var vehicle_vm_name = vehicle_details.display_name;
          var vehicle_vm_capacity = OrderReviewHelper$PorterinFeature.findSpecs(vehicle_details.details, "Capacity");
          var vehicle_vm_dimensions = OrderReviewHelper$PorterinFeature.findSpecs(vehicle_details.details, "Size");
          var vehicle_vm_fare = OrderReviewHelper$PorterinFeature.vehicleFare(quotation, item.vehicle_id);
          var vehicle_vm_dil_uuid = item.dil_uuid;
          var vehicle_vm_without_discount = OrderReviewHelper$PorterinFeature.vehicleWithoutDiscount(quotation, item.vehicle_id);
          var vehicle_vm_discount = OrderReviewHelper$PorterinFeature.vehicleDiscount(quotation, item.vehicle_id);
          var vehicle_vm_gold_discount = OrderReviewHelper$PorterinFeature.vehicleGoldDiscount(quotation, item.vehicle_id);
          var vehicle_vm_eta = String(Belt_Option.getWithDefault(item.eta_mins, 0)) === "0" ? undefined : String(Belt_Option.getWithDefault(item.eta_mins, 0)) + " min";
          var vehicle_vm_selected_icon = {
            path: vehicle_details.icons.selected,
            alt_text: vehicle_details.display_name + " Icon"
          };
          var vehicle_vm_enlarged_icon = {
            path: vehicle_details.icons.enlarged,
            alt_text: vehicle_details.display_name + " Icon"
          };
          var vehicle_vm_deselected_icon = {
            path: vehicle_details.icons.deselected,
            alt_text: vehicle_details.display_name + " Icon"
          };
          var vehicle_vm_disabled_icon = {
            path: vehicle_details.icons.disabled,
            alt_text: vehicle_details.display_name + " Icon"
          };
          var vehicle_vm_allowed_goods_type_ids = vehicle_details.allowed_goods_type_ids;
          var vehicle_vm_fare_breakup = OrderReviewHelper$PorterinFeature.vehicleFareBreakdown(quotation, item.vehicle_id);
          var vehicle_vm = {
            vehicle_id: vehicle_vm_vehicle_id,
            quotation_uuid: vehicle_vm_quotation_uuid,
            name: vehicle_vm_name,
            capacity: vehicle_vm_capacity,
            dimensions: vehicle_vm_dimensions,
            fare: vehicle_vm_fare,
            dil_uuid: vehicle_vm_dil_uuid,
            without_discount: vehicle_vm_without_discount,
            discount: vehicle_vm_discount,
            gold_discount: vehicle_vm_gold_discount,
            eta: vehicle_vm_eta,
            selected_icon: vehicle_vm_selected_icon,
            enlarged_icon: vehicle_vm_enlarged_icon,
            deselected_icon: vehicle_vm_deselected_icon,
            disabled_icon: vehicle_vm_disabled_icon,
            allowed_goods_type_ids: vehicle_vm_allowed_goods_type_ids,
            fare_breakup: vehicle_vm_fare_breakup
          };
          var match = vehicle_vm_fare;
          if (match === "0" || Js_array.includes(vehicle_vm_vehicle_id, restricted_vehicles)) {
            return ;
          } else {
            Js_array.push(vehicle_vm, available_vehicles);
            return ;
          }
        }), quotation.nearby_vehicle_drivers);
  return moveToStart(available_vehicles, selected_vehicle);
}

function selectedVehicleFare(results) {
  if (results !== undefined) {
    return results.fare;
  } else {
    return "";
  }
}

function updateVehiclesAndRestrictions(restrictions, all_vehicles, pickup_latLng, drop_latLng, dispatch) {
  var res_pickup = OrderReviewHelper$PorterinFeature.handleRestrictedVehicles("PickUp", pickup_latLng, restrictions);
  var res_drop = OrderReviewHelper$PorterinFeature.handleRestrictedVehicles("Drop", drop_latLng, restrictions);
  Curry._1(dispatch, {
        TAG: /* SetRestrictedVehicles */12,
        _0: Js_array.concat(res_pickup, res_drop)
      });
  Curry._1(dispatch, {
        TAG: /* SetVehicleDetails */11,
        _0: all_vehicles
      });
}

function defaultGoodsType(goods, vehicle_id) {
  var val = Js_array.find((function (item) {
          return item.vehicle_id === vehicle_id;
        }), goods);
  if (val !== undefined) {
    return {
            id: val.id,
            name: val.name
          };
  }
  
}

function vehicleFareVm(vehicle) {
  return {
          vehicle_id: vehicle.vehicle_id,
          name: vehicle.name,
          capacity: vehicle.capacity,
          fare: vehicle.fare,
          discount: vehicle.discount,
          gold_discount: vehicle.gold_discount,
          without_discount: vehicle.without_discount,
          dimensions: vehicle.dimensions,
          eta: vehicle.eta,
          image: vehicle.deselected_icon,
          selected_image: vehicle.enlarged_icon,
          fare_breakup: vehicle.fare_breakup
        };
}

var commonAssetPath = "/assets/icons/common/booking-flow/";

export {
  commonAssetPath ,
  goods_type ,
  discount_tag ,
  porter_gold_tag ,
  search ,
  getSeoContent ,
  moveToStart ,
  createVehiclesVm ,
  selectedVehicleFare ,
  updateVehiclesAndRestrictions ,
  defaultGoodsType ,
  vehicleFareVm ,
}
/* OrderReviewHelper-PorterinFeature Not a pure module */
